import { videos, type Video } from "@/mocks/videos";

export function getVideoById(id: string): Video | undefined {
  return videos.find((v) => v.id === id);
}

export function getVideosByType(type: string): Video[] {
  return videos.filter((v) => v.type === type);
}

export function getFeaturedVideos(): Video[] {
  return videos.filter((v) => v.featured);
}

export interface FilterOptions {
  region: string;
  year: string;
  rating: string;
  sort: "latest" | "hot";
}

export const defaultFilters: FilterOptions = {
  region: "全部",
  year: "全部",
  rating: "全部",
  sort: "latest",
};

export function filterAndSort(type: string, options: FilterOptions): Video[] {
  let list = getVideosByType(type);

  if (options.region !== "全部") {
    list = list.filter((v) => v.region === options.region);
  }
  if (options.year !== "全部") {
    list = list.filter((v) => String(v.year) === options.year);
  }
  if (options.rating !== "全部") {
    const min = parseInt(options.rating, 10);
    if (!Number.isNaN(min)) list = list.filter((v) => v.rating >= min);
  }

  if (options.sort === "hot") {
    list = [...list].sort((a, b) => b.views - a.views);
  } else {
    list = [...list].sort((a, b) => b.year - a.year);
  }

  return list;
}

export function searchVideos(keyword: string): Video[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return videos.filter(
    (v) =>
      v.title.toLowerCase().includes(kw) ||
      v.genres.some((g) => g.toLowerCase().includes(kw)) ||
      v.region.toLowerCase().includes(kw) ||
      v.typeLabel.toLowerCase().includes(kw)
  );
}

export function getRelated(video: Video, limit = 6): Video[] {
  const sameType = videos.filter((v) => v.type === video.type && v.id !== video.id);
  const shareGenre = sameType.filter((v) => v.genres.some((g) => video.genres.includes(g)));
  const rest = sameType.filter((v) => !shareGenre.includes(v));
  return [...shareGenre, ...rest].slice(0, limit);
}

export function buildEpisodes(total: number): { index: number; title: string; duration: string }[] {
  return Array.from({ length: total }, (_, i) => ({
    index: i + 1,
    title: `第 ${i + 1} 集`,
    duration: `${40 + (i % 5) * 3} 分钟`,
  }));
}